import { useEffect, useState } from "react";
import type { EventContent } from "@tih/shared";
import { fetchEvent } from "../api/client";
import { applyEventTheme } from "../lib/event-theme";
import { preloadImage } from "../lib/preload-image";

type BootState = {
  ready: boolean;
  progress: number;
  eventPayload: EventContent | null;
  error: string | null;
};

export function useComingSoonBoot(): BootState {
  const [ready, setReady] = useState(false);
  const [progress, setProgress] = useState(0.4);
  const [eventPayload, setEventPayload] = useState<EventContent | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function boot() {
      try {
        setProgress(0.45);
        const data = await fetchEvent();
        if (cancelled) return;

        setProgress(0.65);
        applyEventTheme(data.theme);
        setEventPayload(data);

        setProgress(0.85);
        await preloadImage(data.posterUrl);
        if (cancelled) return;

        setProgress(1);
        setReady(true);
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : String(err));
        setProgress(1);
        setReady(true);
      }
    }

    void boot();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ready, progress, eventPayload, error };
}
